(function() {
	var moduleName = "TEXTAREA";
	Modules[moduleName]=function(){};
	//생성
	Modules[moduleName].create=function(parent,data,createComplete){

		//질문이 있는 경우
		if((data.QUESTION||"")!=""){
			var question = $('<div class="s-question"></div>').appendTo(parent);
			if((data.QNUM||"")==""){
				$(question).html(Replacer(data.QUESTION));
			} else {
				var flex=$('<div class="display-flex"></div>').appendTo(question);
				$('<div class="flex-width-0 mr-1"></div>').appendTo(flex).html(Replacer(data.QNUM));
				$('<div class="flex-width-1"></div>').appendTo(flex).html(Replacer(data.QUESTION));
			}
		}

		//설명문이 있는 경우
		if((data.DESC||"")!=""){
			var desc = $('<div class="s-desc"></div>').appendTo(parent);
			$(desc).html(Replacer(data.DESC));
		}

		//응답칸 추가
		var answerBox = $('<div class="s-answer"></div>').appendTo(parent);
		var textareaWrapper = $('<div class="display-flex"></div>').appendTo(answerBox);
		var input=$('<textarea></textarea>').appendTo(textareaWrapper);
		var height=data.HEIGHT||"";
		var minLength=data.MIN_LENGTH||"";
		var maxLength=data.MAX_LENGTH||"";
		if(height=="" || isNaN(height))height="150";
		if(minLength=="" || isNaN(minLength))minLength="1";
		if(maxLength=="" || isNaN(maxLength))maxLength="9999";
		$(input).css({
			"width":"100%"
			,"height":height
		});
		$(input).attr({
			"qname":data.NAME
			,"data-column":"1"
			,"data-min-length":minLength
			,"data-max-length":maxLength
		});

		//기존에 응답한 내용 있으면 넣어주자
		if(PD(data.NAME)["1"]!=null){
			$(input).val(PD(data.NAME)["1"]).trigger('keyup');
		}

		//값제한이 있다면 속성으로 넣어둠
		$(parent).attr('data-TEXT_ALLOW',JSON.stringify(data.TEXT_ALLOW));
		$(parent).attr('data-TEXT_DENY',JSON.stringify(data.TEXT_DENY));

		//무응답 통과문구가 있는 경우
		if((data.PASS||"")!=""){
			var div=$('<div class="s-pass"></div>').appendTo(answerBox);
			var label = $('<label></label>').appendTo(div).addClass('pure-checkbox').attr('for',data.NAME+"_PASS");
			var input = $('<input type="checkbox"/>').appendTo(label);
			var dataColumn="PASS";
			input.attr({
				'id': data.NAME + "_PASS"
				,'name': data.NAME + "_PASS"
				,'data-column': dataColumn
				,'data-pass': true
			});
			$(input).val("PASS");
			$('<span></span>').appendTo(label).html(data.PASS);
			//기존에 응답한 것이면 표시
			if(PD(data.NAME)[dataColumn]=="Y"){
				$(input).prop('checked',true);
			}
			//무응답시 이동할 문항이 지정되어 있나
			if((data.PASS_NEXT||"")!=""){
				$(parent).attr('pass-next',data.PASS_NEXT);
			}
			Modules[moduleName].passProcess(parent);
		}

		createComplete();
	}
	//응답확인
	Modules[moduleName].answered = function (wrapper) {
		var qname=$(wrapper).attr('question-name');
		//무응답에 체크했으면 확인할 필요가 없다
		if($(wrapper).find('input[data-pass]:checked').length>0){
			return true;
		}

		//값제한 확인 준비
		var TEXT_ALLOW=$(wrapper).attr('data-TEXT_ALLOW')||"";
		if(TEXT_ALLOW=="")TEXT_ALLOW="[]";
		var TEXT_DENY=$(wrapper).attr('data-TEXT_DENY')||"";
		if(TEXT_DENY=="")TEXT_DENY="[]";
		var allows=JSON.parse(TEXT_ALLOW);
		var denys=JSON.parse(TEXT_DENY);

		//응답은 했나?
		var input=$('textarea[qname="'+qname+'"]');
		var val=$(input).val().trim();
		if(val==""){
			if(Survey.ANIMATION_SKINS.includes(Q.CONFIG.SKIN)) warningFocus(input);
			Survey.Warning(Lang('NEED_ANSWER'));
			return false;
		}
		//최소 길이 확인
		if(val.length<Number($(input).attr('data-min-length'))){
			if(Survey.ANIMATION_SKINS.includes(Q.CONFIG.SKIN)) warningFocus(input);
			Survey.Warning(Lang('MIN_LENGTH',[$(input).attr('data-min-length')]));
			return false;
		}
		//최대 길이 확인
		if(val.length>Number($(input).attr('data-max-length'))){
			if(Survey.ANIMATION_SKINS.includes(Q.CONFIG.SKIN)) warningFocus(input);
			Survey.Warning(Lang('MAX_LENGTH',[$(input).attr('data-max-length')]));
			return false;
		}

		//정규식 확인
		var ko = $(wrapper).attr('data-regex_ko') === "true";
		var en = $(wrapper).attr('data-regex_en')=== "true"
		var num = $(wrapper).attr('data-regex_num')=== "true"
		var special = $(wrapper).attr('data-regex_special') === "true"
		if(ko||en||num||special){
			/*denys=[] //정규식 체크시 정규식 제한에 입력한 정규식 무시
			allows=[] //정규식 체크시 정규식 허용에 입력한 정규식 무시*/
			var isValid = TH.isValid2(ko,en,num,special,val)
			if(isValid.error){
				if(Survey.ANIMATION_SKINS.includes(Q.CONFIG.SKIN)) warningFocus(input);
				Survey.Warning(Lang(isValid.msg));
				return false;
			}
		}else{
			//값 제한 확인
			var validInfo=TH.isValid(val,allows,denys,true);
			if(!validInfo.VALID){
				if(validInfo.MSG==""){
					Survey.Warning(Lang('NEED_ANSWER'));
				} else {
					Survey.Warning(validInfo.MSG);
				}
				if(Survey.ANIMATION_SKINS.includes(Q.CONFIG.SKIN)) warningFocus(input);
				return false;
			}
		}
		return true;
	}
	//무응답 체크 처리
	Modules[moduleName].passProcess = function (wrapper) {
		var qname=$(wrapper).attr('question-name');
		if($(wrapper).find('input[data-pass]:checked').length>0){
			//무응답에 체크한 경우
			$(wrapper).find('textarea[qname="'+qname+'"]').attr('disabled','disabled').val('');
		} else {
			//무응답 체크 해제한 경우
			$(wrapper).find('textarea[qname="'+qname+'"]').removeAttr('disabled');
		}
	}
	//데이터 뽑기
	Modules[moduleName].getData = function (wrapper) {
		var qname=$(wrapper).attr('question-name');
		var data = {};
		//텍스트
		data["1"]=$('textarea[qname="'+qname+'"]').val().trim();
		//무응답체크
		$(wrapper).find('input:checkbox[data-column]').each(function(){
			if($(this).prop('checked')){
				data[$(this).attr('data-column')]="Y";
				data['NEXT']=$(wrapper).attr('pass-next');
			} else {
				data[$(this).attr('data-column')]="";
			}
		});
		return data;
	}
	//무응답 선택시 처리
	Survey.on('click','div[question-type="'+moduleName+'"] input[data-pass]',function(evt){
		Modules[moduleName].passProcess($('div[question-type="'+moduleName+'"]'));
	});

	//자동응답
	Modules[moduleName].autoAnswer = function (wrapper) {
		var qname=$(wrapper).attr('question-name');
		//문자칸 처리
		$('textarea[qname="'+qname+'"]').visible().each(function(){
			var min=$(this).attr('data-min-length');
			var max=$(this).attr('data-max-length');
			var len=GetOne(min,max);
			var val="";
			while(len>0){
				val+=String.fromCharCode(Math.floor(Math.random()*26)+65);
				len--;
			}
			$(this).val(val);
		});
	}

})();
